// Patchbay (Fase 9.2): las integraciones como conexiones de un rack, vistas de
// frente. Cable conectado = arriba; cable suelto en rojo = caída; toma vacía =
// sin configurar. El estado también va en texto (nunca solo color).
import React from 'react';
import { fmtTime } from '../chat/format';
import { INTEGRATION_STATUS } from '../supervision/labels';

const COL = 124;
const H = 150;

export default function Patchbay({ integrations, theme }) {
  const c = theme.colors;
  const W = integrations.length * COL + 48;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ display: 'block', maxHeight: 180 }}
      role="img" aria-label={`${theme.words.patchbay}: ${integrations.map(i => `${i.label} ${(INTEGRATION_STATUS[i.status] || INTEGRATION_STATUS.unknown).label}`).join(', ')}`}>
      <rect x={4} y={8} width={W - 8} height={78} rx={6} fill={c.rack} stroke={c.rackEdge} />
      {[[14, 18], [W - 14, 18], [14, 76], [W - 14, 76]].map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r={3} fill={c.rackEdge} stroke="rgba(0,0,0,0.5)" />
      ))}
      {integrations.map((it, i) => {
        const cx = 24 + COL * i + COL / 2;
        const st = INTEGRATION_STATUS[it.status] || INTEGRATION_STATUS.unknown;
        const cable = c.cable[it.status] || c.cable.unknown;
        const connected = it.status === 'up';
        const down = it.status === 'down';
        const sway = i % 2 ? -26 : 26;
        const tip = it.status === 'down'
          ? `${it.label}: caída desde ${fmtTime(it.changed_at)} (${it.last_error || 'sin detalle'})`
          : it.status === 'up' ? `${it.label}: conectada${it.latency_ms != null ? ` · ${it.latency_ms} ms` : ''}` : `${it.label}: ${st.label}`;
        return (
          <g key={it.name}>
            <title>{tip}</title>
            <text x={cx} y={28} fontSize={11.5} fontWeight={800} textAnchor="middle" fill={c.text}>{it.label}</text>
            <text x={cx} y={43} fontSize={9.5} textAnchor="middle" fill={down ? '#fca5a5' : c.muted}>
              {st.icon} {st.label}{connected && it.latency_ms != null ? ` · ${it.latency_ms} ms` : ''}
            </text>
            {/* Toma */}
            <circle cx={cx} cy={62} r={10} fill="#07070b" stroke="#6b7280" strokeWidth={2} />
            <circle cx={cx} cy={62} r={4} fill="#000" />
            {connected && (
              <g>
                <path d={`M ${cx} 66 C ${cx} 118, ${cx + sway} 108, ${cx + sway} ${H}`} fill="none" stroke={cable} strokeWidth={5} strokeLinecap="round" />
                <rect x={cx - 6} y={56} width={12} height={16} rx={3} fill={cable} stroke="rgba(0,0,0,0.4)" />
              </g>
            )}
            {down && (
              <g className="studio-pulse">
                <path d={`M ${cx + 4} 100 C ${cx + 6} 124, ${cx + sway} 120, ${cx + sway} ${H}`} fill="none" stroke={cable} strokeWidth={5} strokeLinecap="round" strokeDasharray="7 5" />
                <rect x={cx - 2} y={90} width={12} height={16} rx={3} fill={cable} stroke="rgba(0,0,0,0.4)" transform={`rotate(18 ${cx + 4} 98)`} />
              </g>
            )}
          </g>
        );
      })}
    </svg>
  );
}
